export class AnnouncementModel {
    id = ""
    title = ""
    text = ""
    type = ""
    images: FeedImages[] = []
    location: any
    data: any
}



export class FeedImages {
    itemType = ""
    itemId = ""
    imageSize = ""
    base64 = ""
    storeId = ""
    rootLink = ''
}